import { Route, Routes } from '@angular/router'
import { AuthGuard } from './@core/auth/guards/auth.guard'
import { managementCockpitGuard } from './features/management/guard/management-cockpit.guard'
import { publicTournamentsGuard } from './features/public-tournament/guard/public-tournaments.guard'
import { environment } from 'src/environments/environment'

// Rotas de uso final/social bloqueadas na web em favor do app nativo, que
// nunca fizeram parte da árvore do DashboardComponent (não têm sidebar/top
// bar para preservar), então continuam em tela cheia, sem casca. As demais
// rotas bloqueadas (feed, match, groups, etc.) vivem dentro de
// dashboard.routing.ts, como filhas de DashboardComponent.
export const APP_ONLY_GATE_PATHS = [
  'profile-config',
  'recover-profile',
  'profile-deleted'
]

function appOnlyGateRoute(path: string): Route {
  return {
    path,
    loadComponent: () =>
      import('./@shared/components/app-only-gate/app-only-gate.component').then(
        m => m.AppOnlyGateComponent
      )
  }
}

/** Catálogo do design system: existe só fora de produção. */
export function devOnlyRoutes(production: boolean): Routes {
  return production
    ? []
    : [
        {
          path: 'design-system',
          loadComponent: () =>
            import('./pages/design-system/design-system.component').then(
              m => m.DesignSystemComponent
            )
        }
      ]
}

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/landing-page/landing-page.module').then(
        m => m.LandingPageModule
      )
  },
  {
    path: 'mobile-login',
    loadComponent: () =>
      import('./pages/mobile-login-page/mobile-login-page.component').then(
        m => m.MobileLoginPageComponent
      )
  },

  ...APP_ONLY_GATE_PATHS.map(appOnlyGateRoute),

  {
    // Web pública de torneios: abre sem login e fica fora do gate do app.
    path: 'torneios',
    canMatch: [publicTournamentsGuard],
    loadChildren: () =>
      import('./pages/public-tournaments/public-tournaments.routing').then(
        m => m.PUBLIC_TOURNAMENT_ROUTES
      )
  },

  {
    // Endereço da primeira versão do Início: agora é o /dashboard.
    path: 'inicio',
    canMatch: [publicTournamentsGuard],
    pathMatch: 'full',
    redirectTo: '/dashboard'
  },

  {
    // Endereço antigo de "Minhas inscrições": redireciona para o /dashboard.
    path: 'minhas-inscricoes',
    canMatch: [publicTournamentsGuard],
    loadChildren: () =>
      import('./pages/public-tournaments/public-tournaments.routing').then(
        m => m.ATHLETE_REGISTRATION_ROUTES
      )
  },

  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    // Área de gestão (Esportes Hub Gestão), com casca própria e fora do
    // DashboardComponent. A flag decide se a rota existe; o perfil
    // configurado é exigido dentro de MANAGEMENT_ROUTES, depois do login.
    path: 'gestao',
    canMatch: [managementCockpitGuard],
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/management/management.routing').then(
        m => m.MANAGEMENT_ROUTES
      )
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth.module').then(m => m.AuthModule)
  },
  ...devOnlyRoutes(environment.production)
]
